import script from "./TagManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./TagManagement.vue?vue&type=script&setup=true&lang=js"

import "./TagManagement.vue?vue&type=style&index=0&id=3d71a042&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d71a042"]])

export default __exports__